var clone = require('clone');
var getResolution = require('../utils/getResolution');
var checkPointNotInRotatedImage = require('../utils/checkPointNotInRotatedImage');
var checkOverlappingRectangles = require('../utils/checkOverlappingRectangles');

function checkDecimals(settings) {
  var positions = settings.digits.positions;
  if (settings.digits.enabled === 0 && (settings.data.valueToUse === 2 || settings.data.valueToUse === 3)) {
    throw new Error('valueToUse = 2 or 3 but digits not enabled');
  }
  if (positions) {
    var resolution = getResolution(settings);
    for (var i = 0; i < positions.length; i++) {
      var pos = positions[i].coords;
      if (checkPointNotInRotatedImage(pos[0], pos[1], resolution.width, resolution.height, settings.orientation)) {
        throw new Error('Digit rect position outside image range (' + pos[0] + ',' + pos[1] + ')');
      }
      if (checkPointNotInRotatedImage(pos[2], pos[3], resolution.width, resolution.height, settings.orientation)) {
        throw new Error('Digit rect position outside image range (' + pos[2] + ',' + pos[3] + ')');
      }
      for (var j = i + 1; j < positions.length; j++) {
        var pos2 = positions[j].coords;
        if (checkOverlappingRectangles(pos, pos2)) {
          throw new Error('Overlapping digit rectangles');
        }
      }
    }
    var clonedPositions = clone(positions);
    clonedPositions.sort(function(a, b) {
      return b.precision - a.precision;
    })
    for (var i = 1; i < clonedPositions.length; i++) {
      var posPrev = clonedPositions[i-1].coords;
      var pos = clonedPositions[i].coords;
      let prevIsDecimal=clonedPositions[i-1].precision%1>0;
      let isDecimal=clonedPositions[i].precision%1>0;
      // digits in wrong order
      if (posPrev[0] > pos[0] && !clonedPositions[i].itronMode && (prevIsDecimal===isDecimal)) {
        throw new Error('Digits in wrong order');
      }
    }
  } else {
    if (settings.digits.enabled === 1) {
      throw new Error('Digits enabled but none configured');
    }
  }
}

module.exports = checkDecimals;


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-settings-check/checks/digits.js
// module id = 850
// module chunks = 0